
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 13"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#5cbfdb","d":"M7.498 1.265a.46.46 0 01-.14.33L2.12 6.804l5.238 5.208a.46.46 0 01-.205.778.466.466 0 01-.451-.126L1.136 7.129a.46.46 0 010-.652L6.702.944a.466.466 0 01.796.321zm5.5 0a.46.46 0 01-.14.33L7.62 6.804l5.238 5.208a.46.46 0 01-.205.778.466.466 0 01-.451-.126L6.636 7.129a.46.46 0 010-.652L12.202.944a.466.466 0 01.796.321z"}})])
          )
        }
      }
    